import {styledByTheme} from "../../../themes/architecture/styled-by-theme";
import {HomePageHeaderArenasContainerDefaultBox} from "./home-page-header-arenas-container.default.box";
import {HomePageHeaderArenasContainerCasino888Box} from "./home-page-header-arenas-container.casino888.box";
import {HomePageHeaderArenasContainerMrGreenBox} from "./home-page-header-arenas-container.mrgreen.box";
import {HomePageHeaderArenasContainerCasino777Box} from "./home-page-header-arenas-container.casino777.box";

export const HomePageHeaderArenasContainerBox = styledByTheme(HomePageHeaderArenasContainerDefaultBox)
    .forCasino888(HomePageHeaderArenasContainerCasino888Box)
    .forMrGreen(HomePageHeaderArenasContainerMrGreenBox)
    .forCasino777(HomePageHeaderArenasContainerCasino777Box)
    .apply();
